import { connect } from "react-redux";
import App from "./components/App";

import {
	displayQuestion,
	skipQuestion,
	submitQuestion,
	selectAnswer,
	toggleAcceptedAnswer,
	setImportance,
	togglePrivacy,
	changeExplanation,
	setGenre,
	fetchQuestion,
} from "ducks/questions";

function mapStateToProps(state) {
	const { questions } = state;
	return questions;
}

function mapDispatchToProps(dispatch) {
	return {
		onSubmit() {
			dispatch(submitQuestion());
		},

		onDisplayQuestion() {
			dispatch(displayQuestion());
		},

		onSkip() {
			dispatch(skipQuestion());
		},

		onSelectAnswer(index) {
			dispatch(selectAnswer(index));
		},

		onToggleAcceptedAnswer(index) {
			dispatch(toggleAcceptedAnswer(index));
		},

		onSetImportance(importance) {
			dispatch(setImportance(importance));
		},

		onTogglePrivacy() {
			dispatch(togglePrivacy());
		},

		onChangeExplanation(explanation) {
			dispatch(changeExplanation(explanation));
		},

		onSetGenre(genre) {
			dispatch(setGenre(genre));
		},

		onFetchQuestion(qid) {
			dispatch(fetchQuestion(qid));
		},
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/apps/questions/index.js